module.exports = __webpack_public_path__ + "media/images/avatarFallback-70fb1e12e3da54b13f13679861696732.png";